import { useState, useEffect } from "react";
import "./Testimonial.css";
import { FaStar } from "react-icons/fa";

const testimonials = [
  {
    name: "Sarvesh",
    place: "Jayanagar",
    text: "I had the best experience selling gold. Staff was friendly and transparent. Highly recommended.",
  },
  {
    name: "Ramesh",
    place: "Bangalore",
    text: "Quick service and best price offered. Payment was instant and smooth.",
  },
  {
    name: "Anita",
    place: "Chennai",
    text: "Professional service with modern technology. Very safe and trustworthy.",
  },
];

export default function Testimonial() {
  const [index, setIndex] = useState(0);

  // auto slide
  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % testimonials.length);
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  const t = testimonials[index];

  return (
    <section className="testimonial-section" id="testimonial">

      {/* TITLE */}
      <div className="testimonial-header">
        <span>TESTIMONIALS</span>
        <h2>What Are They Saying About Us?</h2>
      </div>

      {/* CONTENT */}
      <div className="testimonial-box">

        <p className="quote">
          “ {t.text} ”
        </p>

        <h3>{t.name}</h3>
        <span className="place">{t.place}</span>

        <div className="stars">
          {[...Array(5)].map((_, i) => (
            <FaStar key={i} />
          ))}
        </div>

      </div>

      {/* DOTS */}
      <div className="dots">
        {testimonials.map((_, i) => (
          <span
            key={i}
            className={index === i ? "active" : ""}
            onClick={() => setIndex(i)}
          ></span>
        ))}
      </div>

    </section>
  );
}